/**
 * lang.js
 */
import i18n from "@/local/index";
const BASEURI = "/common";

// 配置网站支持的语言
const langs = {
  en: "en",
  "zh-cn": "zh-CN",
};

// en cn 106 63
const languages = {
  en: "en",
  "zh-CN": "cn",
};
const tids = {
  en: "106",
  "zh-CN": "63",
};

const getLanguage = (lang) => {
  return languages[lang] || "en";
};

/**
 * 获取浏览器的语言设置
 * 如果没找到则返回一个默认值 en
 */
export const getLang = () => {
  let lowerLang = (
    window.navigator.language ||
    window.navigator.browserLanguage ||
    "en"
  ).toLowerCase();

  // default: en
  return langs[lowerLang] || "en";
};

/**
 * 设置 html 标签的 lang
 */
export const setHtmlLang = (lang) => {
  // documentElement 根root HTML
  document.documentElement.setAttribute("lang", lang);
};

export const getProductstypeUrl = (lang) => {
  const language = getLanguage(lang);
  const tid = tids[lang] || "106";
  return `${BASEURI}/productstype.php?language=${language}&tid=${tid}&num=100`;
};

//获取首页数据
export const getIndex = () => {
  const language = getLanguage(i18n.locale);
  return `${BASEURI}/getIndex.php?language=${language}`;
};

//获取关于我们数据
export const getAbout = () => {
  const language = getLanguage(i18n.locale);
  return `${BASEURI}/getAbout.php?language=${language}`;
};
//获取页脚数据
export const getFooter = () => {
  const language = getLanguage(i18n.locale);
  return `${BASEURI}/getFooter.php?language=${language}`;
};
//获取新闻数据
export const getNews = (cid, page, num) => {
  const language = getLanguage(i18n.locale);
  return `${BASEURI}/getNews.php?cid=${cid}&page=${page}&num=${num}&language=${language}`;
};
//获取新闻数据
export const getNewsPage = (id) => {
  const language = getLanguage(i18n.locale);
  return `${BASEURI}/getNewsPage.php?id=${id}&language=${language}`;
};
//获取产品数据
export const getProducts = () => {
  const language = getLanguage(i18n.locale);
  return `${BASEURI}/getProducts.php?language=${language}`;
};
//获取更多产品数据
export const moreProducts = (cid, num) => {
  const language = getLanguage(i18n.locale);
  return `${BASEURI}/moreProducts.php?cid=${cid}&num=${num}&language=${language}`;
};
//获取产品详情
export const getProductPage = (id) => {
  const language = getLanguage(i18n.locale);
  return `${BASEURI}/getProductPage.php?id=${id}&language=${language}`;
};
//上传留言
export const Form = () => {
  // const language = getLanguage(lang)
  return `${BASEURI}/Form.php`;
};
//搜索
export const getSearch = (keyword) => {
  const language = getLanguage(i18n.locale);
  return `${BASEURI}/searchProduct.php?keyword=${keyword}&language=${language}`;
};
